import React from 'react';
import { Grid2X2, List } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useProductstableTranslations } from '@/hooks/useProductstableTranslations';

interface ViewToggleProps {
  view: 'list' | 'grid';
  onViewChange: (view: 'list' | 'grid') => void;
}

export function ViewToggle({ view, onViewChange }: ViewToggleProps) {
  const i18n = useProductstableTranslations();

  return (
    <Tabs
      value={view}
      onValueChange={value => onViewChange(value as 'list' | 'grid')}
      className="h-9"
    >
      <TabsList className="h-9">
        <TabsTrigger value="list" className="flex items-center gap-1 px-3">
          <List className="size-4" />
          <span className="hidden sm:inline">{i18n.getViewToggleText('list')}</span>
        </TabsTrigger>
        <TabsTrigger value="grid" className="flex items-center gap-1 px-3">
          <Grid2X2 className="size-4" />
          <span className="hidden sm:inline">{i18n.getViewToggleText('grid')}</span>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
